import styled from 'styled-components';

import { Select } from '@tillersystems/stardust';

export const StyledSelect = styled(Select)`
  width: 100%;
`;
